import { Component, computed, inject, input, signal } from '@angular/core';
import { Sort } from '@angular/material/sort';

import { SearchViewModel } from '@models/module/grid';
import { DisplayFormats, TableColumn, TablePaginator } from '@shared/components/data-list/common';
import { DataListModule } from '@shared/components/data-list/data-list.module';
import { DEFAULT_INFINITE_PAGE, PAGE_SIZE_OPTIONS } from '@shared/consts';
import { AccessLogTableRow, DocumentDetailsService, DocumentDetailsStore } from '../../common';

@Component({
  selector: 'cipo-access-log-tab',
  templateUrl: './access-log-tab.component.html',
  imports: [DataListModule],
})
export class AccessLogTabComponent {
  private dmStore = inject(DocumentDetailsStore);
  documentDetailsService = inject(DocumentDetailsService);

  entityInstanceId = input<number>();
  currentDocument = computed(() => this.dmStore.documents()[this.entityInstanceId()]);

  tableData = signal<AccessLogTableRow[]>(undefined);
  tableOptions = signal({
    serverPaginationSort: true,
    pagination: {
      pageIndex: 0,
      pageSize: PAGE_SIZE_OPTIONS.default[1],
      pageSizeOptions: PAGE_SIZE_OPTIONS.default,
    },
  });
  tableColumns = signal<TableColumn[]>([
    {
      id: 0,
      name: 'user',
      displayName: 'general.table.name',
      sortable: true,
    },
    {
      id: 1,
      name: 'state_name',
      displayName: 'general.table.state',
      sortable: true,
      align: 'center',
      displayFormatId: DisplayFormats.Status,
    },
    {
      id: 2,
      name: 'accessOn',
      displayName: 'general.table.accessOn',
      sortable: true,
      displayFormatId: DisplayFormats.Date,
    },
  ]);

  ngOnInit() {
    this.loadTableRows({ criteria: '', page: 1, pagesize: this.tableOptions().pagination.pageSize });
  }

  loadTableRows(body: SearchViewModel) {
    const entityInstanceId = this.entityInstanceId();
    const contractId = this.dmStore.documents()[entityInstanceId].params.contractId;
    this.documentDetailsService.getAccessLog({ body, contractId, entityInstanceId }).subscribe(({ data, records }) => {
      this.tableData.update(() => {
        return data.map(doc => ({
          ...doc,
          state_name: {
            bgColor: doc.stateColor,
            color: doc.stateTextColor,
            label: doc.state,
          },
        }));
      });
      this.tableOptions.update(options => ({
        ...options,
        pagination: { ...options.pagination, length: records, pageIndex: body.page - 1, pageSize: body.pagesize },
      }));
    });
  }

  handlePagination({ pageIndex, pageSize }: TablePaginator) {
    this.loadTableRows({ page: pageIndex + 1, pagesize: pageSize ?? DEFAULT_INFINITE_PAGE });
  }
  handleSort(event: Sort) {
    const searchModel: SearchViewModel = {
      sort: [
        {
          field: event.active,
          order: event.direction === 'asc' ? 1 : 0,
        },
      ],
      page: 1,
      pagesize: this.tableOptions().pagination.pageSize,
    };
    this.loadTableRows(searchModel);
  }

  searchLogs(criteria: string) {
    this.loadTableRows({
      criteria,
      page: 1,
      pagesize: this.tableOptions().pagination.pageSize,
    });
  }
}
